import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { AttentionMessage } from '@eika/attention-message';

import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';
import isServiceError from '../../utils/isServiceError';
import CombinedServiceNames from './CombinedServiceNames';
import type { TaskManagerType } from './TaskManagerTypes';

import './NoTasksCard.scss';

type Props = {
    errors: Partial<Record<TaskManagerType, RequestExceptionWithResponse | null>>;
};

const GeneralSystemErrorCard: React.FC<Props> = ({ errors }) => {
    const translated = useTranslation();
    const { featureToggles } = useConfig();

    const filteredErrors = (Object.keys(errors) as TaskManagerType[]).filter(
        (key) => !!errors[key] && (!isServiceError(errors[key]) || featureToggles.showSystemErrorsInTaskManager),
    );

    if (filteredErrors.length === 0) return null;

    return (
        <AttentionMessage
            header={translated.taskManager.multipleErrors.title}
            text={<CombinedServiceNames services={filteredErrors} />}
            type="warning"
        />
    );
};

export default GeneralSystemErrorCard;
